import React from 'react'

import GbFlag from '../../assets/images/region/GbFlag'
import UsFlag from '../../assets/images/region/UsFlag'

export const SUPPORTED_REGIONS = ['GB', 'US'] as const
type Props = {
  countryCode: (typeof SUPPORTED_REGIONS)[number]
  className?: string
}

export function Flag({ countryCode, className }: Props): React.ReactElement | null {
  switch (countryCode) {
    case 'US':
      return <UsFlag className={className} />
    case 'GB':
      return <GbFlag className={className} />
    default:
      throw new Error(`Missing flag svg for country code: "${countryCode}"`)
  }
}
